export const REDUCER_NAME = 'task-list'




// WEBPACK FOOTER //
// ./src/modules/process/state/task-list/const.js